import { Component, computed, effect, inject, input, OnDestroy, output, TemplateRef, viewChild } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { FeatureFlag, FeatureFlagService } from "@dcc/shared/feature-flags/data-access";
import { VdsButtonComponent } from "@cce/design-system/button";
import { DrawerHeaderComponent, VdsDrawer, VdsDrawerRef } from "@cce/design-system/drawer";
import { VdsSwitchComponent } from "@cce/design-system/switch";
import { VdsIconComponent } from "@cce/design-system/icon";

const TOGGLE_FLAG = "feature-flags-toggle";

@Component({
    selector: "dcc-feature-flags-sidebar",
    templateUrl: "./sidebar.component.html",
    imports: [DrawerHeaderComponent, VdsButtonComponent, VdsSwitchComponent, VdsIconComponent]
})
export class SidebarComponent implements OnDestroy {
    private features = inject(FeatureFlagService);
    public featureFlags = toSignal(this.features.allFlags$, { initialValue: [] });

    public filteredFeatureFlags = computed(() => {
        return this.featureFlags().filter((flag) => flag.key !== TOGGLE_FLAG);
    });

    public drawer = inject(VdsDrawer);
    public drawerRef: VdsDrawerRef<any> | undefined;

    public open = input<boolean>(false);

    public drawerTpl = viewChild.required("drawerTpl", { read: TemplateRef });

    public close = output<any>();

    public ngOnDestroy(): void {
        // setTimeout because openDrawer is sometimes on a timeout
        // when this runs and can reopen the drawer
        // after this component is already destroyed.
        setTimeout(() => this.closeDrawer());
    }

    constructor() {
        effect(() => {
            const shouldBeOpen = this.open();
            const isOpen = !!this.drawerRef;

            setTimeout(() => {
                // Change detection console error without this
                if (!isOpen && shouldBeOpen) {
                    this.openDrawer();
                } else if (isOpen && !shouldBeOpen) {
                    this.closeDrawer();
                }
            });
        });
    }

    public openDrawer(): void {
        this.drawerRef = this.drawer.open(this.drawerTpl(), {
            position: "right",
            width: "400px"
        });

        this.drawerRef?.afterClosed().subscribe((val) => this.close.emit(val));
    }

    public closeDrawer(): void {
        if (this.drawerRef) {
            this.drawerRef.close();
        }

        this.drawerRef = undefined;
    }

    public toggleFlag(_event: boolean, flag: FeatureFlag): void {
        this.features.toggleFeatureFlag(flag);
    }
}
